/**
 * Constants configuration.
 */
export const ACCEPTED_DOCUMENT_TYPES =
  '.doc, .docx, .jpg, .jpeg, .pdf, .png, .svg, application/msword, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png, image/svg+xml'

export const ACCEPTED_FILE_EXTENSIONS = ['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png', 'svg']

export const MAX_MB = 20

export const SNACKBAR_CLOSE_TIMEOUT = 5000

export const SUSTAINABLE_PURCHASES_FILE = 'instructivo-de-compras-publicas-sustentables.pdf'

export const YES_NO_DICTIONARY = {
  NO: 'false',
  YES: 'true'
}

export const YES_NO_OPTIONS = [
  {
    label: 'Sí',
    value: YES_NO_DICTIONARY.YES
  },
  {
    label: 'No',
    value: YES_NO_DICTIONARY.NO
  }
]
